import { useSelector, useDispatch } from "react-redux";
import React, { useState } from "react";
import Question from "./Question";
import { Button } from "@material-ui/core";
import {
  getCurrentQuestion,
  getQuestions,
  incrementQuestion,
  decrementQuestion,
  saveAndNext,
} from "../../features/Questions/questionSlice";

function LeftPage({ PaperEnd }) {
  const currentQ = useSelector(getCurrentQuestion);
  const Questions = useSelector(getQuestions) || [];
  const dispatch = useDispatch();
  const [ans, setAns] = useState("");
  // console.log(Questions);
  let backDisabled = true;
  let nextDisabled = false;
  let submitDisabled = false;
  // const [ans, setAns] = useState("");

  if (currentQ === 1) backDisabled = true;
  else backDisabled = false;
  if (currentQ === Questions.length) nextDisabled = true;
  else nextDisabled = false;
  const sendDataToParent = (ans) => {
    // the callback. Use a better name
    //  console.log(index);
    setAns(ans);
  };
  const submit = () => {
    dispatch(saveAndNext(ans));
    if (window.confirm("submit ?")) {
      PaperEnd();
    }
    return;
  };
  // console.log(currentQ);
  return (
    <div>
      <Question sendDataToParent={sendDataToParent} />
      <div
        className="d-flex justify-content-between"
        style={{ width: "83%", marginLeft: "20px" }}
      >
        <div>
          <Button
            variant="contained"
            disabled={backDisabled}
            color="default"
            onClick={() => {
              dispatch(decrementQuestion());
              // setAns(Questions[currentQ-1].attempted);
            }}
          >
            {"<<"}
          </Button>
          <Button
            disabled={nextDisabled}
            style={{ marginLeft: "20px" }}
            variant="contained"
            color="default"
            onClick={() => {
              dispatch(incrementQuestion());
              // setAns(Questions[currentQ - 1].attempted);
            }}
          >
            {">>"}
          </Button>
        </div>
        <div>
          <Button
            variant="contained"
            disabled={submitDisabled}
            color="primary"
            style={{ alignSelf: "right" }}
            onClick={submit}
          >
            SUBMIT
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LeftPage;
